@if (confirmationSuccessful) {
  <p class="success">
    Your account has been successfully confirmed!<br />
    You can now
    <a class="success__sing-in-link" routerLink="/auth/sign-in"
      ><strong>sign in</strong></a
    >.
  </p>
} @else if (errorMessage) {
  <p class="error">
    {{ errorMessage }}
  </p>
}
